var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section",attrs:{"id":"files-personal-settings"}},[_c('h2',[_vm._v(_vm._s(_vm.t('files', 'Files')))]),_vm._v(" "),_c('TransferOwnershipDialogue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }